module.exports = __webpack_public_path__ + "assets/img/informationDate_first2.59a5c210.svg";